import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeButtonModule } from "@tylertech/forge-angular";
import { SecurityRoute, SecurityStorageKey, StorageService } from "../../../services";

@Component({
    selector: "signout-form",
    templateUrl: "./signoutForm.tmpl.html",
    imports: [
        LayoutAlignDirective,
        LayoutDirective,
        ForgeButtonModule,
    ]
})
export class SignoutFormComponent implements OnInit
{
    private readonly router = inject(Router);
    private readonly $storageService = inject(StorageService);


    ngOnInit(): void
    {
        // TODO - we should be consolidating stored data access within the appropriate services instead of just hard-coding things all over the place.
        this.$storageService.Remove(SecurityStorageKey.TidToken);
    }

    return(): void
    {
        this.router.navigate([SecurityRoute.Login], { queryParamsHandling: "preserve" });
    }
}
